import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SignUp } from 'src/app/common-class/survey';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';

// Window interface extension to support older ActiveXObject
interface ExtendedWindow extends Window {
  ActiveXObject?: new (type: string) => XMLHttpRequest;
}

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css'],
})
export class SignUpComponent implements OnInit {
  isUpButton: boolean;
  userEmail: string;
  response: string;
  key: string = '';

  signUp: SignUp;

  constructor(
    private service: ParticipationDataService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      this.key = params['k'];
    });
    this.signUp = this.service.getSignup();
  }

  ProcessSignUpOnEnter(event: number) {
    if (event == 13) {
      this.ProcessSignUp();
      return false;
    }
  }

  ProcessSignUp() {
    this.AjaxCall();
  }

  CloseSignUp(event: Event) {
    event.stopPropagation();
    
    // Convert jQuery to native JavaScript
    const bodyElement = document.querySelector('.sign-up-container-body') as HTMLElement;
    if (bodyElement) {
      // Native slideUp implementation
      const currentHeight = bodyElement.offsetHeight;
      bodyElement.style.overflow = 'hidden';
      bodyElement.style.height = currentHeight + 'px';
      bodyElement.style.transition = 'height 500ms';
      setTimeout(() => {
        bodyElement.style.height = '0px';
      }, 0);
    }
    
    const slideUpElements = document.querySelectorAll('.slide-up');
    slideUpElements.forEach(el => (el as HTMLElement).style.display = 'block');
    
    const slideDownElements = document.querySelectorAll('.slide-down');
    slideDownElements.forEach(el => (el as HTMLElement).style.display = 'none');
    
    const headerElement = document.querySelector('.sign-up-container-header');
    if (headerElement) {
      headerElement.setAttribute('click', 'OpenSignUp(event);');
    }

    if (this.isUpButton) {
      this.isUpButton = false;
    }
  }

  OpenSignUp(event: Event) {
    if (this.service.GroupType.toLowerCase() == 'preview') {
      return;
    }

    if (this.isUpButton) {
      this.CloseSignUp(event);
    } else {
      // Convert jQuery to native JavaScript
      const bodyElement = document.querySelector('.sign-up-container-body') as HTMLElement;
      if (bodyElement) {
        // Native slideDown implementation
        bodyElement.style.overflow = 'hidden';
        bodyElement.style.height = '0px';
        bodyElement.style.transition = 'height 500ms';
        setTimeout(() => {
          const height = bodyElement.scrollHeight;
          bodyElement.style.height = height + 'px';
          // After animation, reset to auto to allow content changes
          setTimeout(() => {
            bodyElement.style.height = 'auto';
            bodyElement.style.overflow = 'visible';
          }, 500);
        }, 0);
      }
      
      const slideUpElements = document.querySelectorAll('.slide-up');
      slideUpElements.forEach(el => (el as HTMLElement).style.display = 'none');
      
      const slideDownElements = document.querySelectorAll('.slide-down');
      slideDownElements.forEach(el => (el as HTMLElement).style.display = 'block');
      
      const headerElement = document.querySelector('.sign-up-container-header');
      if (headerElement) {
        headerElement.setAttribute('click', 'CloseSignUp(event);');
      }

      if (!this.isUpButton) {
        this.isUpButton = true;
      }
    }
  }

  SignInGoogle() {
    const accountType = this.signUp.accountType;
    const signInType = this.signUp.signInType;
    let strURL =
      this.signUp.strHostPath.replace('http:', window.location.protocol) +
      'static/Intermediate/GoogleSignInProcessing.aspx?ref=' +
      this.signUp.ref +
      '&k=' +
      this.key +
      '&lang=' +
      this.service.getSelectedLanguage();

    if (accountType.length > 0) {
      strURL += '&TrialAccType=' + accountType + '&participation=1';
    }

    if (signInType) {
      window.open(strURL, '_google', 'width=505,height=585,scrollbars=yes');
    } else {
      window.open(
        this.signUp.strHostPath.replace('http:', window.location.protocol) +
          'static/Intermediate/GoogleSignInProcessing.aspx?TrialAccType=' +
          accountType +
          '&ref=' +
          this.signUp.ref,
        '_google',
        'width=505,height=585,scrollbars=yes' +
          '&k=' +
          this.key +
          '&lang=' +
          this.service.getSelectedLanguage(),
      );
    }
  }

  SignInFacebook() {
    const accountType = this.signUp.accountType;
    const FaceBookID = this.signUp.FaceBookID;
    const strhost = this.signUp.strHostPath.replace('http:', window.location.protocol);
    const strURL =
      'https://graph.facebook.com/oauth/authorize?client_id=' +
      FaceBookID +
      '&redirect_uri=' +
      strhost +
      'static/Intermediate/FacebookIntermediate.aspx?page=4&state=' +
      accountType +
      '@ref=@timeoffset=@participation=1@lang=' +
      this.service.getSelectedLanguage() +
      '@k=' +
      this.key +
      '&scope=email&amp;display=page';
    window.open(strURL, '_facebook');
  }

  AjaxCall() {
    let xmlhttp: XMLHttpRequest;
    
    if (window.XMLHttpRequest) {
      // code for modern browsers
      xmlhttp = new XMLHttpRequest();
    } else {
      // Fallback for older IE browsers
      try {
        xmlhttp = new (window as ExtendedWindow).ActiveXObject('Microsoft.XMLHTTP');
      } catch (e) {
        console.error('XMLHttpRequest not supported');
        return;
      }
    }
    
    xmlhttp.onreadystatechange = () => {
      if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
        const btnOkElement = document.getElementById('btnOk');
        if (btnOkElement) btnOkElement.style.display = 'none';
        
        this.response = xmlhttp.responseText;
        const labelMessage = this.parseHTML('lblMess');
        
        const errorMessElement = document.getElementById('error_mess');
        if (errorMessElement) errorMessElement.innerHTML = labelMessage;
        
        if (labelMessage == 'sucessful') {
          // Successful case handling would go here
          console.log('Signup successful');
        } else if (labelMessage == 'invalid') {
          // Invalid case handling would go here
          console.log('Invalid signup');
        } else if (labelMessage == 'login') {
          const redirectURL = this.parseHTML('lblRedirectUrl');
          const strUrlWelcome = decodeURIComponent(redirectURL);
          const finalUrl = 
            strUrlWelcome.replace(
              this.signUp.strParticipationServer.replace('http:', 'https:'),
              this.signUp.strHostPath.replace('http:', 'https:'),
            ) + '&participation=1';
          const win = window.open(finalUrl, '_blank');
          if (win) win.focus();
        } else if (labelMessage.indexOf('To use the administrative features') != -1) {
          // Administrative features handling would go here
          console.log('Admin features message received');
        } else {
          if (
            labelMessage.indexOf('Our records indicate that you already have an account with us') !=
            -1
          ) {
            const loginURL =
              this.signUp.strHostPath
                .replace('https:', window.location.protocol)
                .replace('http:', window.location.protocol) +
              'static/login.aspx?ActMsg=21&eid=' +
              this.userEmail +
              '&SignupByEmail=1' +
              '&k=' +
              this.key +
              '&lang=' +
              this.service.getSelectedLanguage();
            const win = window.open(loginURL, '_blank');
            if (win) win.focus();
          } else {
            const elements = [
              { id: 'btnLog', display: 'none' },
              { id: 'btnOk', display: '' },
              { id: 'a_cancel', display: 'none' },
              { id: 'overs1', display: '' },
              { id: 'fadeDiv1', display: '' }
            ];
            
            elements.forEach(item => {
              const element = document.getElementById(item.id);
              if (element) element.style.display = item.display;
            });
          }
        }
        
        const lblMessElement = document.getElementById('lblMess');
        if (lblMessElement === null || lblMessElement.innerHTML != 'login') {
          // Non-login case handling would go here
          console.log('Non-login state detected');
        }
      }
    };
    
    // Get email value without jQuery
    const emailElement = document.getElementById('txtEmailId') as HTMLInputElement;
    const emailValue = emailElement ? emailElement.value : '';
    
    const fullUrl = this.signUp.strHostPath +
      'static/AjaxFreesignup.aspx?isCaptcha=False&isValidate=True&istrial=0&emailaddress=' +
      emailValue +
      '&ref=&SignUpFrom=participation';
    xmlhttp.open('GET', fullUrl + '&rnd=' + Math.random() * 9999, false);
    xmlhttp.send();
  }

  RedirectUrl() {
    const loginURL =
      this.signUp.strHostPath
        .replace('https:', window.location.protocol)
        .replace('http:', window.location.protocol) +
      'static/login.aspx?ActMsg=21&eid=' +
      this.userEmail;
    const win = window.open(loginURL, '_blank');
    if (win) win.focus();
  }

  parseHTML(id: string) {
    let regex;
    switch (id) {
      case 'lblMess':
        regex = /<span id="lblMess">(.*)<\/span>/;
        break;
      case 'lblAccountType':
        regex = /<span id="lblAccountType">(.*)<\/span>/;
        break;
      case 'lblRedirectUrl':
        regex = /<span id="lblRedirectUrl">(.*)<\/span>/;
        break;
      default:
        break;
    }

    const values = this.response.match(regex);
    if (values && values.length > 1) {
      return values[1];
    }
    return '';
  }

  CloseModal() {
    const elements = [
      { id: 'overs1', display: 'none' },
      { id: 'fadeDiv1', display: 'none' }
    ];
    
    elements.forEach(item => {
      const element = document.getElementById(item.id);
      if (element) element.style.display = item.display;
    });
  }
}
